/* eslint-disable no-nested-ternary */
import React, { useState, useContext, useEffect } from 'react';
import moment from 'moment';
import ReactGA from 'react-ga4';

import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';
import { Table } from 'reactstrap';
import { toast } from 'react-toastify';

import { LoaderLista } from '~/components/Loaders';
import { symbolPriceFormatter } from '~/helpers/price';

import { PedidoContext } from '~/context/PedidoContext';
import { FiltroCredRevenda } from '~/components/Filtros/FiltroCredRevenda';
import { TrStyled, SolicitarButtonStyled } from './styles';

export function ExtratoCreditoRevenda(props) {
	const { user, isMobile } = props;
	const { resumos, loadingResumo, setLoadingResumo, getResumo, totalItemsResumo, loadingRevendedores, getExportResumo } = props;

	const {
		postSolicitacao
	} = useContext(PedidoContext);

	const [pagina, setPagina] = useState(1);

	const [filtroOrder, setFiltroOrder] = useState('');
	const [filtroPesquisa, setFiltroPesquisa] = useState('');

	function handlerPagination(page) {
		setPagina(page);
		getResumo(10, page, filtroOrder, filtroPesquisa)
	}

	useEffect(() => {
		getResumo(10, pagina, filtroOrder, filtroPesquisa)
	}, [filtroOrder, filtroPesquisa]);

	const SolicitaRevenda = (id) => {
		toast.success('Crédito Solicitado!')
		setLoadingResumo(false)

		postSolicitacao(id).then(
			getResumo()
		)
		handleClickSolicitarViewSaldoGA4();
	}

	function handleClickSolicitarViewSaldoGA4() {
		ReactGA.event({
			category: "solicitar_saldo_click",
			action: "Solicitar Saldo",
			label: "Solicitando Saldo",
		});
	}

	const downloadResumo = async() => {
		await getExportResumo(filtroPesquisa);
	}

	return (
		<>
			<FiltroCredRevenda
				user={user}
				setFiltroPesquisa={setFiltroPesquisa}
				setFiltroStatus={setFiltroOrder}
				filtroStatus={filtroOrder}
				setPagina={setPagina}
				loadingRevendedores={loadingRevendedores}
				downloadResumo={downloadResumo}
			/>
			<LoaderLista loading={!loadingResumo} lista={resumos}>
				<Table id="test-table-xls-button" responsive>
					<thead>
						<TrStyled>
							<th>{user.dados.cargo.toLowerCase() === 'distribuidor - matriz' ? 'Documento' : 'Atualização'}</th>
							{user.dados.permissoes.view_credito_distribuidor || user.dados.cargo.toLowerCase() === 'industria' ?
								<th style={{ textAlign: 'left' }}>Distribuidores</th> :
								(user.dados.permissoes.view_farmacias ? <th style={{ textAlign: 'left' }}>Farmácias</th> : <th style={{ textAlign: 'left' }}>Revendedores</th>)}
							{user.dados.permissoes.view_credito_revenda && <th>Crédito</th>}
						</TrStyled>
					</thead>
					<tbody>
						{resumos.map((item, index) => {
							return (
								<tr key={`${item.descricao}-${index}`} style={{ textAlign: 'center' }}>
									<td>
									   {user.dados.cargo.toLowerCase() === 'distribuidor - matriz' ? item?.documento : (item?.atualizado_em ? moment(item.atualizado_em).format(
											'DD/MM/YYYY'
										): '')}
									</td>
									<td style={{ textAlign: 'left' }}>{item.nome}</td>
									{user.dados.permissoes.view_credito_revenda ?
										<>
											{item.descricao.toLowerCase() === 'aprovado' && <td>{symbolPriceFormatter(item.saldo)}</td>}

											{item.descricao.toLowerCase() === 'reprovado' && <td>--</td>}

											{(item.descricao.toLowerCase() === 'pendente' || item.descricao.toLowerCase() === '') &&
												<td>
													<SolicitarButtonStyled
														outline
														color="primary"
														disabled={item.descricao.toLowerCase() === 'pendente'}
														onClick={() => SolicitaRevenda(item.id)}>
														{item.descricao.toLowerCase() === 'pendente' ? 'SOLICITADO' : 'SOLICITAR'}
													</SolicitarButtonStyled>
												</td>
											}
										</> :
										<></>}
								</tr>
							);
						})}
					</tbody>
				</Table>

				<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
					<Pagination
						activePage={pagina}
						totalItemsCount={totalItemsResumo}
						onChange={(page) => handlerPagination(page)}
						prevPageText={<ChevronLeftOutlined />}
						nextPageText={<ChevronRightOutlined />}
						firstPageText={<FirstPageOutlined />}
						lastPageText={<LastPageOutlined />}
					/>
				</div>
			</LoaderLista>
		</>
	);
}
